import { useEffect, useState } from 'react'
import Lottie from 'react-lottie-player'
import { connect } from 'react-redux'
import { formatDate } from '../../libs/dates'
import { formatNumber } from '../../libs/utils'
import { isDiscountEnabledSelector } from '../../reducers/itemEntryReducer'
import { authenticatedSelector } from '../../reducers/userReducer'
import TableRow from '../babu/TableRow'
import BottomButtonArea from '../common/BottomButtonArea'
import NavBar from '../common/NavBar'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'

/*
  purchaseResult (normal): {
    "order_number": "CAO0000008722",  // 訂單編號
    "title": "團購名稱",
    "contact": "+886912345678",  // 賣家聯絡資訊 (若無手機號碼則為email)
    "price": 2000,    // 商品金額 (台幣/每份)
    "instalment": 6,  // 分期期數
    "instalment_amount": 333, // 分期金額 (台幣/一期)，若無分期則為0
    "payment_type": "credit_card", // 付款方式 (credit_card: 信用卡; reward: 回饋折抵)
    "payment_amount": 335, // 不分期/首期應付金額 (台幣)
    "discount": 315,       // 不分期/首期折抵金額 (台幣)
    "paid": 20,            // 不分期/首期付款金額 (台幣)
    "exchange_rate": 31,   // 台幣兌美元匯率
    "message": "感謝您的訂購",  // 交易訊息
    "timestamp": "2020-08-03T02:51:52Z" // 交易時間 (UTC)
  }
  purchaseResult (instalment): {
    "order_number": "CAO0000008726",  // 訂單編號
    "title": "團購名稱",
    "contact": "+886912345678",     // 賣家聯絡資訊 (若無手機號碼則為email)
    "payment_amount": 666,          // 付款總金額 (台幣)
    "payment_type": "credit_card",  // 付款方式 (目前僅開放信用卡)
    "exchange_rate": 31,            // 台幣兌美元匯率
    "message": "感謝您的訂購",       // 交易訊息
    "transaction_time": "2020-08-06T07:46:24.091Z",  // 交易時間 (UTC)
    "instalments": [   // 分期款項列表
      {
        "instalment_id": 131,  // 分期款項ID
        "period_num": 2,       // 分期期數 (第二期)
        "payment_amount": 333  // 分期金額
      },
      {
        "instalment_id": 132,
        "period_num": 3,
        "payment_amount": 333
      }
    ]
  }
 */

function PurchaseSuccess(props) {
  const {
    authenticated,
    // isPeriodicPayment,
    isDiscountEnabled,
    purchaseResult,
    vendor,
  } = props
  const referral = vendor?.referral

  let data
  if (purchaseResult.status) {
    data = purchaseResult.data
  } else {
    data = purchaseResult
  }

  const {
    discount,
    paid,
    // price: pricePerQty,
    // qty: quantity, // * get from POST request body, not from response
    // max_qty: maxQuantity, // * get from POST request body, not from response
    // exchange_rate: exchangeRate,
    payment_amount: paymentAmount,
  } = data

  const timestamp = data.timestamp || data.transaction_time

  const [successAnimationData, setSuccessAnimationData] = useState(undefined)
  useEffect(() => {
    import('../../animation/illust-done_2.json').then(
      setSuccessAnimationData,
      () => {
        console.warn('import illust-done_2.json error')
      },
    )
  }, [])

  const usedDiscount =
    isDiscountEnabled && authenticated && !data.instalments && discount > 0

  useGA4Pageview('slash_payment_redeem', usedDiscount)
  useGA4Pageview('slash_payment_noredeem', !usedDiscount)

  return (
    <>
      <NavBar />
      {referral ? (
        <BottomButtonArea
          variant="solid"
          onClick={() => {
            window.location.href = referral.url
          }}>
          {referral.title}
        </BottomButtonArea>
      ) : null}
      <div className="container mt-navbarSpacing text-center mb-l">
        {successAnimationData ? (
          <Lottie
            className="mt-l mb-0 mx-auto"
            play
            loop={false}
            animationData={successAnimationData}
            style={{ width: 180, height: 180 }}
          />
        ) : (
          <div style={{ height: 180 }} />
        )}
        <h4 className="babu-text-subtitle text-text600 mb-xs">付款完成</h4>
        <p className="babu-text text-text600">
          {authenticated
            ? '你可以在信件內查看訂單訊息'
            : '你可以在手機簡訊查看訂單訊息'}
        </p>
      </div>
      <div className="container px-xs mb-30">
        <TableRow
          content="訂單編號"
          accessoryLabel={data.order_number}
          accessoryLabelClassName="babu-text-paragraph-bold"
          divided
        />
        <TableRow
          content="消費日期"
          accessoryLabel={formatDate(new Date(timestamp), 'yyyy.MM.dd HH:mm')}
          accessoryLabelClassName="babu-text-paragraph-bold"
          divided
        />
        <TableRow
          content="訂單金額"
          accessoryLabel={`NT$${formatNumber(paymentAmount)}`}
          accessoryLabelClassName="babu-text-paragraph-bold"
          divided
        />
        {discount ? (
          <TableRow
            content="回饋折抵"
            accessoryLabel={`-$${formatNumber(discount)}`}
            accessoryLabelClassName="babu-text-paragraph-bold text-primary900"
            divided
          />
        ) : null}
        <TableRow
          content="付款金額"
          accessoryLabel={`NT$${formatNumber(paid)}`}
          accessoryLabelClassName="babu-text-paragraph-bold"
          divided
        />
      </div>
    </>
  )
}

export default connect(state => ({
  authenticated: authenticatedSelector(state.user),
  // isPeriodicPayment: isPeriodicPaymentSelector(state.itemEntry),
  isDiscountEnabled: isDiscountEnabledSelector(state.itemEntry),
  vendor: state.vendor,
}))(PurchaseSuccess)
